import NotAMemberModalImage from '@/allas/public/image/not-a-member-modal.png';
import { DynamicStandaloneButton } from '@/components/Button';
import { DynamicStandaloneIcon } from '@/components/Icon';
import useUserAuth from '@/hooks/useUserAuth';
import { StandaloneComponent } from '@/types/component';
import { StandaloneSaveArticleButton, StandaloneSaveArticleButtonProps } from 'base/components/SaveArticleButton';
import mergeProps from 'lib/utils/mergeProps';
import NextImage from 'next/image';

const AllasStandaloneSaveArticleButton: typeof StandaloneSaveArticleButton = (props) => {
  const { logInUrl, signUpUrl } = useUserAuth();

  return (
    <StandaloneSaveArticleButton
      {...mergeProps(
        {
          options: { $button: { colors: 'secondary' } },
          modalContent: (
            <div className="relative flex flex-col-reverse items-center md:flex-row">
              <DynamicStandaloneIcon
                options={{ size: 'medium', className: 'cursor-pointer absolute right-2 top-2' }}
                name="close"
              />
              <NextImage src={NotAMemberModalImage} alt="" />
              <div className="flex max-w-90 flex-col items-center gap-y-3 px-6 py-8 md:py-0">
                <span className="text-al-body-md mb-1 text-center">
                  För att spara den här artiklen så måste du vara inloggad
                </span>
                <DynamicStandaloneButton link={{ href: logInUrl }} content="Logga in på ditt konto" />
                <span className="text-al-body-md">eller</span>
                <DynamicStandaloneButton
                  link={{ href: signUpUrl }}
                  options={{ colors: 'secondary' }}
                  content="Skapa ett konto"
                />
              </div>
            </div>
          ),
        },
        props
      )}
    />
  );
};

export default AllasStandaloneSaveArticleButton;
